export const MessagesLoadingState = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <p className="text-content-300 text-sm">Loading messages...</p>
    </div>
  );
};
